const { Serializer } = require("jsonapi-serializer");

module.exports = {
  ResetPasswordSerializer: (meta = {}) =>
    new Serializer("reset_password", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["token", "password"]
    })
};
